import { ServerCrash } from "lucide-react";
import { cn } from "~/lib/utils";

interface AssistantUnavailableProps {
  className?: string;
}

export function AssistantUnavailable({ className }: AssistantUnavailableProps) {
  return (
    <div className={cn("flex h-full items-center justify-center bg-white", className)}>
      <div className="flex flex-col items-center gap-3 text-center">
        <ServerCrash className="size-10 text-gray-400" />
        <p className="text-lg font-medium text-gray-700">Analysis Agent is unavailable</p>
        <p className="text-sm text-gray-500">
          Please try again later or contact support if the issue persists.
        </p>
      </div>
    </div>
  );
}
